<template>
    <div class="app" style="background-color: #eff2f5">
        <section>
            <hospital-select @selected="selectHospital"></hospital-select>
            <voucher-select :list="voucherList" @selected="selectVoucher"></voucher-select>
        </section>
        <scroll class="from-query" @refresh="refresh" style="padding-bottom: 2rem">
            <section class="thick" v-for="unpay in unpayList" @click="goDetail(unpay)">
                <div class="panel">
                    <span>{{unpay.deptName}}</span>
                </div>
                <div class="row arr-row table-row">
                    <div class="col">
                        <span class="f-minor">总金额</span>&nbsp;&nbsp;<span
                            class="f-strongest">{{unpay.totalFee | formatFee}}</span>
                        <br>
                        <span class="f-minor">开单时间</span>&nbsp;&nbsp;<span
                            class="f-minor">{{unpay.visitTime | formatpayDate}}</span>
                        <br>
                    </div>
                    <div class="col">
                        <!--<button v-show="canPay(unpay.canPay)" @click.stop="confirm(unpay)"-->
                                <!--class="btn-minor-orange btn-position">缴费-->
                        <!--</button>-->
                    </div>
                </div>
            </section>
            <no-record :condition="unpayList" :tips="nodataTitle"></no-record>
        </scroll>
        <footer>
            <button v-show="unpayList.length > 0" class="btn-complete" type="button" @click="confirm(unpayList)" style="border-radius:0">缴费</button>
        </footer>
        <payConfirm v-model="showPayConfirm"></payConfirm>
    </div>
</template>
<script>
    import queryFun from 'queryFunList.service'
    import queryVoucher from 'voucher.service'
    import VoucherSelect from 'VoucherSelect'
    import HospitalSelect from 'HospitalSelect'
    import NoRecord from 'NoRecord'
    import PayConfirm from 'PayConfirm'

    export default {
        components: {
            VoucherSelect,
            HospitalSelect,
            NoRecord,
            PayConfirm
        },
        data() {
            return {
                fee: '',
                orderId: '',
                voucher: {
                    cardNo: '',
                    cardType: '',
                    holderName: '',
                    hospitalName: ''
                },
                unpayList: [],
                unpayInfo: {},
                voucherList: [],
                noRecord: false,
                nodataTitle: '暂无缴费！',
                showPayConfirm: false
            }
        },
        mounted() {
            this.messagePush();
        },
        methods: {
            messagePush() {
                var query = this.$router.currentRoute.query;
                //区分消息推送和正常页面跳转
                if (query.cardNo) {
                    //设置医院消息头和localStorage
                    const hospital = {
                        "hospitalId": query.hospitalId,
                        "hospitalIndex": query.hospitalIndex,
                        "hospitalName": query.hospitalName,
                        "hospitalType": query.hospitalType
                    };
                    localStorage.selectedHospital = JSON.stringify(hospital);
                    window.http.headers.common['hospitalId'] = hospital.hospitalId;
                }
                this.loadVouchers();
            },
            loadVouchers() {
                // 获取用户就诊凭证
                queryVoucher.getVoucherList().then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.$utils.alert(res.resultMsg);
                        return;
                    }

                    const data = res.data;
                    if (data.length === 0) {
                        this.$utils.alert('请先绑定诊疗卡');
                        return;
                    }
                    this.voucherList = data;
                    // 首次进入，默认第一张诊疗卡信息
                    this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

                    // 保存默认卡信息
                    this.$store.commit('updateParam', {
                        namespace: 'mypay',
                        voucher: this.voucher,
                    });
                    this.refresh();
                });
            },
            refresh() {
                var params = {
                    cardType: this.voucher.cardType,
                    cardNo: this.voucher.cardNo
                };

                //处理初始进入微信的未选医院情况
                if (typeof(http.headers.common['hospitalId']) == "undefined") {
                    this.$utils.alert("请选择医院");
                    return
                }
                //处理未绑定就诊凭证
                if (!this.voucher.cardType || !this.voucher.cardNo) {
                    return this.$utils.alert('请先绑定诊疗卡')
                }

                this.loadClinicList(params);
            },
            //选择就诊凭证
            selectVoucher(v) {
                this.unpayList = this.constant.ARRAY_CLEAN;
                this.voucher = v;

                //保存默认卡信息
                this.$store.commit('updateParam', {
                    namespace: 'mypay',
                    voucher: v
                });
                //加载默认卡的待缴费列表
                this.refresh();
            },
            //选择医院
            selectHospital() {
                this.unpayList = this.constant.ARRAY_CLEAN;
                this.refresh();
            },
            //查询门诊缴费列表
            loadClinicList(params) {
                queryFun.getClinicList(params).then((res) => {

                    if (res.resultCode === this.constant.RESULT_SUCCESS) {
                        res = res.data;
                        this.unpayList = res || [];
                    } else {
                        //this.$utils.alert(res.resultMsg);
                        this.unpayList = []
                        return;
                    }
                })
            },
            //去未缴费详单
            goDetail: function (unpay) {
                //区分消息推送和正常页面跳转
                this.$store.commit('updateParam', {
                    namespace: 'myUnpay',
                    unpay: unpay,
                    queryParam: {
                        cardType: this.voucher.cardType,
                        cardNo: this.voucher.cardNo,
                        holderName: this.voucher.holderName,
                        visitId: unpay.visitId,
                        fee: unpay.totalFee,
                        startDate: unpay.visitTime,
                        endDate: unpay.visitTime,
                        orderType: 2,
                        deptName: unpay.deptName,
                        doctName: unpay.doctName,
                        canPay: unpay.canPay,
                        visitName: unpay.visitName,
                    }
                })
                this.$router.push('clinicUnpayDetail')
            },
            //支付
            confirm(unpayList) {
                //确认缴费 生成orderId
                var visitIds;
                for (var i = 0; i < unpayList.length; i++) {
                    if (i == 0) {
                        visitIds = unpayList[i].visitId
                    } else {
                        visitIds = visitIds + ',' + unpayList[i].visitId
                    }
                }
                this.$http.post('/app/clinic/unpay/confirm', {
                    cardType: this.voucher.cardType,
                    cardNo: this.voucher.cardNo,
                    visitId: visitIds
                }).then(res => {
                    var result = res.data;
                    if (result.resultCode === this.constant.RESULT_SUCCESS) {
                        this.orderId = res.data.data.orderId;
                        this.fee = res.data.data.fee;
                        this.goPay();
                    } else {
                        this.$utils.alert(res.data.resultMsg)
                    }
                });
            },
            goPay() {
                //将数据存入本地
                this.$store.commit('updateParam', {
                    namespace: 'pay',
                    payInfo: {
                        cardType: this.voucher.cardType,
                        cardNo: this.voucher.cardNo,
                        name: this.voucher.holderName,
                        orderType: 2,
                        fee: this.fee,
                        orderId: this.orderId,
                        busiType: '2'
                    },
                });
                //缴费成功后自动跳转到已缴费详单。存入数据
//                this.$store.commit('updateParam', {
//                    namespace: 'mypay',
//                    pay: unpay,
//                    queryParam: {
//                        holderName: unpay.holderName,
//                        cardType: this.voucher.cardType,
//                        cardNo: this.voucher.cardNo,
//                        orderTime: unpay.visitTime,
//                        orderId: this.orderId,
//                        visitName: unpay.visitName,
//                        doctName: unpay.doctName,
//                        fee: unpay.totalFee
//                    }
//                });
                this.showPayConfirm = true;
            },
            canPay(canpay) {
                return canpay === 1;
            },
        },
        watch: {
            unpayList(val) {
                this.noRecord = val.length === 0;
            }
        }
    }
</script>
<style>
    .btn-position {
        float: right;
    }
</style>



// WEBPACK FOOTER //
// ClinicUnpayList.vue?db9efa14